import React, { useState } from 'react';
const faqs = [{
  question: '¿A qué edad puedo empezar a aplicar el protocolo?',
  answer: 'Desde el día 1 de vida. Los pilares de Sueño y Estimulación son aplicables desde la primera semana. El protocolo está diseñado para acompañar todo el primer año con ajustes específicos para cada etapa.'
}, {
  question: '¿Cuánto tiempo tarda en verse resultados?',
  answer: 'Muchos padres reportan mejoras en el sueño en menos de 72 horas al implementar las Ventanas de Vigilia y la Rutina de 4 Elementos. Los resultados completos del protocolo se consolidan en 2-4 semanas.'
}, {
  question: '¿Es compatible con la lactancia materna?',
  answer: '100%. El protocolo es completamente agnóstico al tipo de alimentación. La lactancia materna es el vehículo ideal de DHA y anticuerpos, y el protocolo está diseñado para potenciarla, no reemplazarla.'
}, {
  question: '¿Funciona si tengo gemelos?',
  answer: 'Sí. La clave con gemelos es sincronizar sus rutinas desde el inicio. El protocolo de Ventanas de Vigilia es especialmente crítico para mantener la sintonía entre dos bebés y es perfectamente aplicable.'
}, {
  question: '¿Cómo recibo los materiales?',
  answer: 'Inmediatamente después de tu compra recibirás un email con los enlaces de descarga del ebook principal y los 4 bonos en formato PDF. El acceso es instantáneo, 24/7.'
}, {
  question: '¿Necesito comprar materiales especiales?',
  answer: 'No. El 90% del protocolo usa lo que ya tienes en casa. El cerebro de tu bebé y tu voz son las herramientas más poderosas. El Bono 4 "Ahorra $2000 en su Primer Año" te muestra exactamente qué NO necesitas comprar.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="bg-[#FAF7F2] py-16 px-5" data-id="element-37">
      <div className="max-w-[900px] mx-auto" data-id="element-38">
        <div className="text-center mb-2.5" data-id="element-39">
          <span className="inline-block bg-[rgba(183,110,121,0.1)] text-[#B76E79] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-40">
            Resolvemos tus dudas
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#3D2B1F] mb-12 leading-tight text-center" data-id="element-41">
          Preguntas Frecuentes
        </h2>

        <div className="max-w-[750px] mx-auto space-y-3" data-id="element-42">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-xl overflow-hidden shadow-sm" data-id="element-43">
              <button onClick={() => toggleFAQ(idx)} className="w-full bg-transparent p-5 flex justify-between items-center text-base text-[#3D2B1F] font-semibold text-left transition-colors hover:bg-[#FAF7F2]" data-id="element-44">
                <span className="pr-4" data-id="element-45">{faq.question}</span>
                <span className={`text-2xl text-[#B76E79] flex-shrink-0 transition-transform ${openIndex === idx ? 'rotate-45' : ''}`} data-id="element-46">
                  +
                </span>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ${openIndex === idx ? 'max-h-96 pb-5' : 'max-h-0'}`} data-id="element-47">
                <p className="px-6 text-sm text-[#6B4C3B] font-sans leading-relaxed" data-id="element-48">
                  {faq.answer}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}